export default __webpack_public_path__ + "asset/img/more-shipping-list-4~981ba335.png";